import { useSelector } from 'react-redux';

// Maps each "Other" quantity translation key to its "Adj" equivalent.
const OTHER_TO_ADJ_KEY = {
    'reportUsage.itemList.other': 'reportUsage.itemList.adj',
    'reportUsage.review.itemsToBeBilled.ItemsToBeBilled.other':
        'reportUsage.review.itemsToBeBilled.ItemsToBeBilled.adj',
    'reportUsage.review.itemsToBeBilled.ItemsToBeBilled.otherQty':
        'reportUsage.review.itemsToBeBilled.ItemsToBeBilled.adjQty',
    'reportUsage.record.priceOverride.AccountOwnedList.index.other':
        'reportUsage.record.priceOverride.AccountOwnedList.index.adj',
};

/**
 * Returns a resolver that swaps the "Other" quantity label key for its "Adj"
 * equivalent when `adjustmentDisEnabled` is set on the user profile.
 */
export const useAdjQtyLabel = () => {
    const adjustmentDisEnabled = useSelector(
        (state) => state.loginReducer?.hybrisUserDetails?.adjustmentDisEnabled
    );
    return (otherKey) =>
        (adjustmentDisEnabled && OTHER_TO_ADJ_KEY[otherKey]) || otherKey;
};
